<template>
    <div class="row">
        <div class="col-12 mb-4">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div class="d-flex align-items-center">
                    <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
                        <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
                    </button>
                    <div>
                        <h3 class="text-white font-weight-bold mb-1">{{ $t('profile.resetPasswordTitle') }}</h3>
                        <p class="text-muted small mb-0">{{ $t('profile.resetPasswordSubtitle') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 grid-margin">
            <div class="card border border-subtle">
                <div class="card-body p-4">
                    <form class="forms-sample" @submit.prevent="submitForm" enctype="multipart/form-data">
                        <div class="form-group row">
                            <div class="col-md-8 mb-3">
                                <label for="currentPassword" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.currentPassword') }}</label>
                                <div class="input-group">
                                    <input :type="showCurrent ? 'text' : 'password'" class="form-control" id="currentPassword"
                                        v-model="userStore.current_password" :placeholder="$t('profile.currentPasswordPlaceholder')" required />
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-secondary" 
                                        style="border-color: #2c2e33; background: #2a3038;"
                                        @click="showCurrent = !showCurrent"
                                        :title="showCurrent ? $t('profile.hidePassword') : $t('profile.showPassword')"
                                    >
                                        <i :class="showCurrent ? 'mdi mdi-eye-off text-warning' : 'mdi mdi-eye text-muted'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-8 mb-3">
                                <label for="newPassword" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.newPassword') }}</label>
                                <div class="input-group">
                                    <input :type="showNew ? 'text' : 'password'" class="form-control" id="newPassword"
                                        v-model="userStore.new_password" :placeholder="$t('profile.newPasswordPlaceholder')" required />
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-secondary" 
                                        style="border-color: #2c2e33; background: #2a3038;"
                                        @click="showNew = !showNew"
                                        :title="showNew ? $t('profile.hidePassword') : $t('profile.showPassword')"
                                    >
                                        <i :class="showNew ? 'mdi mdi-eye-off text-warning' : 'mdi mdi-eye text-muted'"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-8 mb-3">
                                <label for="confirmNewPassword" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.confirmNewPassword') }}</label>
                                <div class="input-group">
                                    <input :type="showConfirm ? 'text' : 'password'" class="form-control" id="confirmNewPassword"
                                        v-model="userStore.confirm_new_password" :placeholder="$t('profile.confirmNewPasswordPlaceholder')" required />
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-secondary" 
                                        style="border-color: #2c2e33; background: #2a3038;"
                                        @click="showConfirm = !showConfirm"
                                        :title="showConfirm ? $t('profile.hidePassword') : $t('profile.showPassword')"
                                    >
                                        <i :class="showConfirm ? 'mdi mdi-eye-off text-warning' : 'mdi mdi-eye text-muted'"></i>
                                    </button>
                                </div>
                                <div v-if="userStore.new_password && userStore.confirm_new_password && userStore.new_password !== userStore.confirm_new_password" class="text-danger mt-1 small" role="alert">
                                    {{ $t('profile.passwordMismatch') }}
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end gap-2 mt-4">
                            <button type="button" @click="back"
                                class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                                {{ $t('common.back') }}
                            </button>
                            <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold"
                                :disabled="loading || userStore.new_password !== userStore.confirm_new_password">
                                <span class="spinner-border spinner-border-sm mr-1" role="status" v-if="loading"></span>
                                <i class="mdi mdi-check-all mr-1" v-else></i> {{ $t('profile.updatePassword') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { updateProfilePassword } from "@/services/authService";
import config from "@/config/config";
import Swal from "sweetalert2";
import store from '@/store';

export default {
    name: "EditUserPassword",
    data() {
        let resolvedId = null;
        try {
            const raw = store.state.user || localStorage.getItem('user');
            let parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            if (typeof parsed === 'string') parsed = JSON.parse(parsed);
            resolvedId = parsed?.data?.id || parsed?.id || null;
        } catch (e) {
            resolvedId = null;
        }

        return {
            userStore: {
                current_password: "",
                new_password: "",
                confirm_new_password: "",
            },
            showCurrent: false,
            showNew: false,
            showConfirm: false,
            id: resolvedId,
            config,
            loading: false,
        };
    },
    mounted() {},
    methods: {
        async submitForm() {
            this.loading = true;
            try {
                const response = await updateProfilePassword(this.id, this.userStore);
                console.log(response);

                Swal.fire({
                    icon: "success",
                    title: this.$t('common.success'),
                    text: this.$t('profile.passwordUpdatedSuccess'),
                    confirmButtonColor: "#0090e7",
                });

                this.$router.go(-1);
            } catch (error) {
                const errMsg = error.response?.data?.errors?.[0] || error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? "Gagal memperbarui password" : "Failed to update password");
                Swal.fire({
                    icon: "error",
                    title: this.$t('common.error'),
                    text: errMsg,
                    confirmButtonColor: "#0090e7",
                });
            } finally {
                this.loading = false;
            }
        },
        back() {
            this.$router.go(-1);
        },
    },
};
</script>